import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "shareIos"
const ShareIosIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M9 9.75H4.875V21H18.375V9.75H15V8.25H18.375C19.203 8.25 19.875 8.922 19.875 9.75V21C19.875 21.828 19.203 22.5 18.375 22.5H4.875C4.047 22.5 3.375 21.828 3.375 21V9.75C3.375 8.922 4.047 8.25 4.875 8.25H9z" />
          <path d="M16.28 5.845 15.22 6.905 12.75 4.435V15.75H11.25V4.436L8.78 6.906 7.72 5.844 12 1.565z" />
        </svg>
      }
    </span>
  )
}
export default ShareIosIcon
